import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';

import { EntityMarkdownCard } from '../EntityMarkdown/EntityMarkdownCard';
import { TemplateDescriptionCard } from '../TemplateDescriptionCard';
import { TemplatePrerequisites } from '../TemplatePrerequisites';
import { EntityWarningContent } from './EntityWarningContent';
import { techdocsContent } from './TechdocsContent';

export const TemplateEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <EntityWarningContent />
        <Grid item xs={12} md={6}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TemplateDescriptionCard />
            </Grid>
            <Grid item xs={12}>
              <EntityMarkdownCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} style={{ alignSelf: 'flex-start' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TemplatePrerequisites />
            </Grid>
            <EntitySwitch>
              <EntitySwitch.Case if={entity => Boolean(entity.metadata.links?.length)}>
                <Grid item xs={12}>
                  <EntityLinksCard />
                </Grid>
              </EntitySwitch.Case>
            </EntitySwitch>
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route>
    <EntityLayout.Route path="/details" title="Details">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12}>
          <EntityAboutCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
